var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"Insert Image","visible":_vm.dialog,"width":"750px","top":"3vh","modal":true,"append-to-body":true},on:{"close":function($event){return _vm.setDialog(false)}}},[_c('UploadImage')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }